module.exports = __webpack_public_path__ + "static/media/lounge-image.0dd80105.png";